import { ShellIconBarChart, ShellIconClipboardList } from '@zrsystem/ui';

import type { ShellNavEntry } from '@/shared/shell/nav.types.js';

/** Stub MVP — nível `network`. */
export const NETWORK_NAV_ENTRIES: readonly ShellNavEntry[] = [
  {
    kind: 'link',
    id: 'network-home',
    label: 'Painel da rede',
    icon: ShellIconBarChart,
    enabled: true,
  },
  {
    kind: 'link',
    id: 'network-reports',
    label: 'Relatórios',
    icon: ShellIconClipboardList,
    enabled: false,
  },
] as const;
